(() => {
  const init = (root) => {
    if (!root || root.dataset.pelletReady === 'true') return;
    root.dataset.pelletReady = 'true';

    const grid = root.querySelector('[data-pellet-grid]');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-pellet-product]')];
    let orderedCards = [...cards];
    const groups = [...root.querySelectorAll('[data-filter-group]')];
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-pellet-empty]');
    const reset = root.querySelector('[data-pellet-reset]');
    const sort = root.querySelector('[data-pellet-sort]');
    const more = root.querySelector('[data-pellet-more]');
    const resultsHead = root.querySelector('.msp-pellet-results-head');
    const activeFilters = root.querySelector('[data-active-filters]');
    let resultLimit = 12;
    let finderOpen = false;

    const numberFrom = (value) => {
      const match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
      return match ? Number(match[0]) : null;
    };
    const matches = (card, button) => {
      const value = button.dataset.filterValue;
      const group = button.closest('[data-filter-group]')?.dataset.filterGroup || button.dataset.filterTarget;
      if (group === 'power') return card.dataset.room === value;
      if (group === 'kind') return card.dataset.kinds.split(' ').includes(value);
      if (group === 'outlet') {
        if (value.startsWith('diameter-')) return numberFrom(card.dataset.diameter) === Number(value.replace('diameter-', ''));
        if (value === 'top') return ['top', 'both'].includes(card.dataset.outlet);
        if (value === 'rear') return ['rear', 'both'].includes(card.dataset.outlet);
      }
      if (group === 'air') return value === 'external' ? card.dataset.externalAir === 'true' : card.dataset.dibt === 'true';
      if (group === 'vendor') return card.dataset.brand === value;
      if (group === 'comfort') return value === 'app' && card.dataset.app === 'true';
      if (group === 'budget') {
        const price = Number(card.dataset.price);
        if (value === 'to-3500') return price <= 350000;
        if (value === '3500-4500') return price > 350000 && price <= 450000;
        if (value === '4500-6000') return price > 450000 && price <= 600000;
        return value === 'over-6000' && price > 600000;
      }
      return true;
    };
    const activeFor = (group) => [...group.querySelectorAll('[data-filter-value][aria-pressed="true"]')];
    const closeGroup = (group, restoreFocus = false) => {
      const toggle = group?.querySelector('[data-group-toggle]');
      const panel = toggle?.nextElementSibling;
      if (!toggle || !panel) return;
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (restoreFocus && wasOpen) toggle.focus({ preventScroll: true });
    };
    const closeGroups = (except = null) => groups.forEach((group) => {
      if (group !== except) closeGroup(group);
    });
    const activeGroupData = () => groups
      .map((group) => ({ group, active: activeFor(group) }))
      .filter(({ active }) => active.length);

    const apply = () => {
      const activeGroups = activeGroupData();
      const matched = orderedCards.filter((card) => activeGroups.every(({ active }) => active.some((button) => matches(card, button))));
      const shouldShow = finderOpen || activeGroups.length > 0;
      let visible = 0;
      orderedCards.forEach((card) => {
        const match = matched.includes(card);
        const show = shouldShow && match && visible < resultLimit;
        card.hidden = !show;
        if (show) visible += 1;
      });
      grid.hidden = !shouldShow;
      resultsHead?.classList.toggle('is-idle', !shouldShow);
      if (count) count.textContent = shouldShow
        ? `${matched.length} passende${matched.length === 1 ? 'r' : ''} ${matched.length === 1 ? 'Pelletofen' : 'Pelletöfen'}${matched.length > visible ? ` – ${visible} angezeigt` : ''}`
        : 'Wählen Sie mindestens einen Filter';
      if (empty) empty.hidden = !shouldShow || matched.length !== 0;
      if (more) more.hidden = !shouldShow || visible >= matched.length;
      if (activeFilters) activeFilters.replaceChildren(...activeGroups.flatMap(({ active }) => active.map((button) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.textContent = `${button.textContent.trim()} ×`;
        chip.addEventListener('click', () => {
          button.setAttribute('aria-pressed', 'false');
          resultLimit = 12;
          apply();
        });
        return chip;
      })));
      if (reset) reset.disabled = activeGroups.length === 0 && !finderOpen;
    };

    const sortCards = () => {
      const mode = sort?.value || 'recommended';
      orderedCards = [...cards].sort((a, b) => {
        if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      orderedCards.forEach((card) => grid.append(card));
    };

    root.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-filter-value]');
      if (filter) {
        const ownGroup = filter.closest('[data-filter-group]');
        const targetGroup = ownGroup || root.querySelector(`[data-filter-group="${filter.dataset.filterTarget}"]`);
        if (!targetGroup) return;
        if (ownGroup) {
          filter.setAttribute('aria-pressed', filter.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        } else {
          targetGroup.querySelectorAll('[data-filter-value]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.filterValue === filter.dataset.filterValue));
          });
        }
        finderOpen = true;
        resultLimit = 12;
        apply();
        if (ownGroup) closeGroup(ownGroup, true);
        if (filter.hasAttribute('data-scroll-results')) resultsHead?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const groupToggle = event.target.closest('[data-group-toggle]');
      if (groupToggle) {
        const group = groupToggle.closest('[data-filter-group]');
        const panel = groupToggle.nextElementSibling;
        const open = groupToggle.getAttribute('aria-expanded') !== 'true';
        if (open) closeGroups(group);
        groupToggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      }
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('[data-filter-group]')) closeGroups();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openGroup = groups.find((group) => group.querySelector('[data-group-toggle]')?.getAttribute('aria-expanded') === 'true');
      if (!openGroup) return;
      event.preventDefault();
      closeGroup(openGroup, true);
    });
    reset?.addEventListener('click', () => {
      root.querySelectorAll('[data-filter-value][aria-pressed="true"]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      finderOpen = false;
      resultLimit = 12;
      if (sort) sort.value = 'recommended';
      sortCards();
      apply();
    });
    sort?.addEventListener('change', () => {
      sortCards();
      apply();
    });
    more?.addEventListener('click', () => {
      resultLimit += 12;
      apply();
    });
    root.querySelectorAll('[data-open-finder]').forEach((button) => button.addEventListener('click', () => {
      finderOpen = true;
      resultLimit = 12;
      apply();
      resultsHead?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    groups.forEach((group) => {
      group.querySelectorAll('[data-filter-value]').forEach((button) => {
        if (!cards.some((card) => matches(card, button))) button.hidden = true;
      });
      if (![...group.querySelectorAll('[data-filter-value]')].some((button) => !button.hidden)) group.hidden = true;
    });

    const showcase = root.querySelector('[data-pellet-showcase]');
    if (showcase) {
      const tabs = [...showcase.querySelectorAll('[data-pellet-product-tab]')];
      const panels = [...showcase.querySelectorAll('[data-pellet-product-panel]')];
      const activateTab = (name, focus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.pelletProductTab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus({ preventScroll: true });
        });
        panels.forEach((panel) => {
          const active = panel.dataset.pelletProductPanel === name;
          panel.hidden = !active;
          if (active) panel.querySelector('[data-pellet-product-row]').scrollLeft = 0;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab.dataset.pelletProductTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activateTab(tabs[next].dataset.pelletProductTab, true);
        });
      });
      showcase.querySelector('[data-pellet-showcase-next]')?.addEventListener('click', () => {
        showcase.querySelector('[data-pellet-product-panel]:not([hidden]) [data-pellet-product-row]')?.scrollBy({ left: showcase.clientWidth * .82, behavior: 'smooth' });
      });
      activateTab('recommended');
    }

    if (sort) sort.value = 'recommended';
    sortCards();
    apply();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-msp-pellet]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
